
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowUpGoogle as ObiArrowUpGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-up-google.js';
 
 
 

 
 export const ObiArrowUpGoogle = createComponent({
   react: React,
   tagName: 'obi-arrow-up-google',
   elementClass: ObiArrowUpGoogleElement,
   events: {
     
   }
  });
 
 